import React from 'react';
import propTypes from 'prop-types';
export const BookIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 4.960938 19.171875 L 21.320312 19.171875 C 21.375 19.171875 21.421875 19.164062 21.46875 19.15625 C 21.472656 19.15625 21.476562 19.15625 21.476562 19.15625 C 21.828125 19.15625 22.109375 18.871094 22.109375 18.523438 L 22.109375 0.632812 C 22.109375 0.28125 21.828125 0 21.476562 0 L 4.964844 0 C 3.28125 0 1.90625 1.371094 1.90625 3.054688 C 1.90625 3.078125 1.914062 3.101562 1.914062 3.121094 C 1.914062 4.675781 1.894531 18.972656 1.914062 20.851562 C 1.914062 20.890625 1.90625 20.921875 1.90625 20.960938 C 1.90625 22.582031 3.175781 23.90625 4.773438 24.007812 C 4.804688 24.011719 4.835938 24.015625 4.867188 24.015625 L 21.476562 24.015625 C 21.828125 24.015625 22.109375 23.734375 22.109375 23.382812 L 22.109375 21 C 22.109375 20.652344 21.828125 20.367188 21.476562 20.367188 C 21.128906 20.367188 20.84375 20.652344 20.84375 21 L 20.84375 22.75 L 4.960938 22.75 C 4 22.75 3.21875 21.984375 3.179688 21.035156 C 3.179688 21.015625 3.179688 21 3.179688 20.984375 C 3.179688 20.957031 3.179688 20.914062 3.179688 20.855469 C 3.234375 19.917969 4.011719 19.171875 4.960938 19.171875 Z M 5.394531 3.054688 C 5.394531 2.703125 5.679688 2.421875 6.027344 2.421875 C 6.375 2.421875 6.660156 2.703125 6.660156 3.054688 L 6.660156 15.914062 C 6.660156 16.261719 6.375 16.546875 6.027344 16.546875 C 5.679688 16.546875 5.394531 16.261719 5.394531 15.914062 Z M 5.394531 3.054688 "
        />
      </g>
    </svg>
  );
};
BookIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
BookIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
